import { Course } from '@/domain/entities/problem/course'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class GetCourseStatisticsUseCase {
  constructor(private repository: ProblemRepository) {}

  async getCourseStatisticsByLanguage(
    courseName: string,
    userId: string,
    programLanguage: ProgramLanguageType
  ): Promise<Course> {
    try {
      const data = await this.repository.getCourseStatisticsByLanguage(courseName, userId, programLanguage)
      return data
    } catch (error) {
      console.error(`Error in GetCourseStatisticsUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
